import { render, staticRenderFns } from "./UserManagerView.vue?vue&type=template&id=30961c92"
import script from "./UserManagerView.vue?vue&type=script&lang=js"
export * from "./UserManagerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports